<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    tagType: (tagType$ | async),
    availableTags: (availableTags$ | async) ?? []
  }"
>
</ng-container>

<ng-template
  #template
  let-tagType="tagType"
  let-availableTags="availableTags"
>
  <mat-form-field flex>
    <mat-label>{{ tagType.displayName }}</mat-label>
    <mat-select
      [formControl]="formControl"
      (selectionChange)="selectionChanged($event.value)"
    >
      <mat-option [value]="null">{{ noneSelectedText }}</mat-option>
      <mat-option *ngFor="let tag of availableTags; trackBy: trackById" [value]="tag.tagId"
        >{{ tag.displayName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
